import type { PropsWithChildren } from "react";
import { t } from "@/i18n-js/instance";
import { MobileNotSupportedPanel } from "@circle-react-shared/MobileNotSupportedPanel";

export const Container = ({ children }: PropsWithChildren<unknown>) => (
  <>
    <div className="hidden size-full flex-row lg:flex">{children}</div>
    <MobileNotSupportedPanel
      className="lg:hidden"
      title={t("builder_ui.mobile_unsupported.title")}
      description={t("builder_ui.mobile_unsupported.description")}
    />
  </>
);
